import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core'
import { isArray } from 'lodash'
import { map, Subject, takeUntil } from 'rxjs'

import { ClinicService } from '../services/clinic.service'

@Directive({
  selector: '[mmxHasIntegrationSupport]',
  standalone: false,
})
export class HasIntegrationSupportDirective implements OnInit, OnDestroy {
  @Input()
  public appHasIntegrationSupport: string | string[]

  @Input()
  public appHasIntegrationSupportElse: TemplateRef<any> | null = null

  /**
   * To use this input, you need to pass it as an option in the directive selector:
   *
   * <div *appHasIntegrationSupport="['UPDATE_APT', 'UPDATE_APT_RESCHEDULE']; operator: 'AND'">
   */
  @Input()
  public appHasIntegrationSupportOperator: 'AND' | 'IN' | 'OR' = 'AND'

  private onDestroy$ = new Subject<void>()

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private clinicService: ClinicService,
  ) { }

  public ngOnInit() {
    this.clinicService.clinic$.pipe(
      takeUntil(this.onDestroy$),
      map(clinic => {
        const supports = clinic.integration?.supports ?? []
        const features = isArray(this.appHasIntegrationSupport) ? this.appHasIntegrationSupport : [this.appHasIntegrationSupport]
        const operator = this.appHasIntegrationSupportOperator
        return operator === 'AND'
          ? features.every(feature => supports.includes(feature))
          : features.some(feature => supports.includes(feature))
      }),
    ).subscribe((hasFeatures) => this.handleVisibility(hasFeatures))
  }

  public ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }

  private handleVisibility(hasPermission: boolean) {
    this.viewContainer.clear()

    if (hasPermission) {
      return this.viewContainer.createEmbeddedView(this.templateRef)
    }

    if (this.appHasIntegrationSupportElse) {
      this.viewContainer.createEmbeddedView(this.appHasIntegrationSupportElse)
      return
    }
  }
}
